// extracted by mini-css-extract-plugin
export var brandLockup = "_ig-5";
export var brandLogo = "_ig-6";
export var bullet = "_ig-1i";
export var bulletText = "_ig-1h";
export var bullets = "_ig-1c";
export var callout = "_ig-12";
export var calloutBody = "_ig-14";
export var calloutLabel = "_ig-13";
export var checkIcon = "_ig-1e";
export var checkList = "_ig-1b";
export var checkSvg = "_ig-1f";
export var checkText = "_ig-1g";
export var choiceCard = "_ig-x";
export var choiceDescription = "_ig-10";
export var choiceIcon = "_ig-11";
export var choiceText = "_ig-y";
export var choiceTitle = "_ig-z";
export var closeButton = "_ig-d";
export var codeText = "_ig-28";
export var compactPage = "_ig-f";
export var content = "_ig-9";
export var contentColumn = "_ig-3";
export var coverageCard = "_ig-o";
export var coverageDescription = "_ig-24";
export var coverageTitle = "_ig-23";
export var eyebrow = "_ig-i";
export var fieldCard = "_ig-m";
export var fieldDescription = "_ig-r";
export var fieldError = "_ig-s";
export var fieldHeader = "_ig-p";
export var fieldTitle = "_ig-q";
export var finalNote = "_ig-29";
export var footer = "_ig-a";
export var fulfillmentBody = "_ig-1u";
export var fulfillmentBodyText = "_ig-1v";
export var fulfillmentRow = "_ig-1r";
export var fulfillmentRows = "_ig-1q";
export var fulfillmentTitle = "_ig-1t";
export var header = "_ig-4";
export var heading = "_ig-h";
export var helperText = "_ig-1k";
export var indented = "_ig-1x";
export var inlineLink = "_ig-26";
export var inlineTitle = "_ig-2a";
export var intro = "_ig-k";
export var linkPreview = "_ig-1z";
export var listItem = "_ig-1d";
export var main = "_ig-1";
export var marketingImage = "_ig-c";
export var marketingPanel = "_ig-b";
export var modal = "_ig-0";
export var noteBody = "_ig-v";
export var noteBodyText = "_ig-w";
export var noteCard = "_ig-n";
export var noteIcon = "_ig-t";
export var noteTitle = "_ig-u";
export var numberBadge = "_ig-2e";
export var numberedStep = "_ig-2c";
export var numberedStepBody = "_ig-2f";
export var numberedStepCta = "_ig-2d";
export var numberedStepDescription = "_ig-2h";
export var numberedStepTitle = "_ig-2g";
export var numberedSteps = "_ig-2b";
export var page = "_ig-e";
export var playCircle = "_ig-18";
export var playIcon = "_ig-19";
export var policyBody = "_ig-21";
export var policyHeader = "_ig-20";
export var policyPreview = "_ig-1y";
export var policyTitle = "_ig-22";
export var progressFill = "_ig-8";
export var progressTrack = "_ig-7";
export var pseudoLink = "_ig-25";
export var pseudoLinkIcon = "_ig-27";
export var rowHeader = "_ig-1s";
export var section = "_ig-g";
export var shell = "_ig-2";
export var statusIconSuccess = "_ig-1m";
export var statusIconSvg = "_ig-1o";
export var statusIconWarning = "_ig-1n";
export var statusRow = "_ig-1l";
export var statusText = "_ig-1p";
export var stepTitle = "_ig-j";
export var strongText = "_ig-1w";
export var subHeading = "_ig-l";
export var videoEmbed = "_ig-16";
export var videoIframe = "_ig-17";
export var videoLabel = "_ig-1a";
export var videoPlaceholder = "_ig-15";
export var warningIcon = "_ig-1j";